import { render, staticRenderFns } from "./CustomerBabies.vue?vue&type=template&id=8b89fc3c&"
import script from "./CustomerBabies.vue?vue&type=script&lang=js&"
export * from "./CustomerBabies.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBabies.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports